import React from "react";
import * as Icons from "lucide-react";
import { WHY_CHOOSE } from "@/lib/brand";

export default function WhyChoose() {
  return (
    <section data-testid="why-section" id="why-us" className="py-16 md:py-24 bg-soft-blue">
      <div className="container-x">
        <div className="max-w-2xl">
          <h2 className="text-[32px] md:text-[44px] font-extrabold text-navy">Why families choose Velixa</h2>
          <p className="mt-3 text-ink/85">Six things we promise every family — because trust at home starts with the small details.</p>
        </div>

        <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {WHY_CHOOSE.map((w, i) => {
            const Icon = Icons[w.icon] || Icons.HeartHandshake;
            return (
              <article key={i} data-testid={`why-${i}`} className="bg-white rounded-2xl border border-navy/10 p-6 shadow-soft">
                <span className="icon-tile"><Icon className="w-6 h-6" /></span>
                <h3 className="mt-5 text-[18px] font-bold text-navy">{w.title}</h3>
                <p className="mt-1.5 text-[15px] text-ink/80">{w.desc}</p>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}
